import logger from "utils/logger";
// Utility helpers to cache quote results in localStorage

export const QUOTE_CACHE_KEY = "AGIC_QUOTE_CACHE";

/**
 * Save quote payload to cache keyed by policyId.
 * @param {any} payload The quote response payload returned from /quotes/results
 * @param {string|number} policyId The policy identifier the payload belongs to
 * @param {number} ttlMs Time-to-live in milliseconds (default 1h)
 */
export function saveQuoteCache(payload, policyId, ttlMs = 1000 * 60 * 60) {
	if (typeof window === "undefined" || !window.localStorage) return;
	const wrapper = {
		policyId,
		expiresAt: Date.now() + ttlMs,
		data: payload,
	};
	try {
		localStorage.setItem(QUOTE_CACHE_KEY, JSON.stringify(wrapper));
	} catch (err) {
		logger.error("Failed to save quote cache", err);
	}
}

/**
 * Load cached quote payload if still valid.
 * @param {string|number} policyId Expected policy id.
 * @returns {any|null} Cached data or null if none/expired/mismatch.
 */
export function loadQuoteCache(policyId) {
	if (typeof window === "undefined" || !window.localStorage) return null;
	try {
		const raw = localStorage.getItem(QUOTE_CACHE_KEY);
		if (!raw) return null;
		const parsed = JSON.parse(raw);
		if (parsed.expiresAt < Date.now()) {
			clearQuoteCache();
			return null;
		}
		if (policyId !== undefined && parsed.policyId !== policyId) return null;
		return parsed.data;
	} catch (err) {
		logger.error("Failed to load quote cache", err);
		return null;
	}
}

export function clearQuoteCache() {
	if (typeof window === "undefined" || !window.localStorage) return;
	try {
		localStorage.removeItem(QUOTE_CACHE_KEY);
	} catch (err) {
		logger.error("Failed to clear quote cache", err);
	}
}
